import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Field,
  reduxForm,
  formValueSelector,
  initialize,
  change,
} from 'redux-form';
import { injectIntl } from 'react-intl';
import Form from 'react-bootstrap/Form';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import Link from '../../Link/Link';
import Loader from '../../Common/Loader/Loader';
import ImageUploadComponent from '../../../components/Common/ImageUploadComponent';
import InputFieldComponent from '../../Common/InputFieldComponent/InputFieldComponent';
import SelectFieldComponent from '../../Common/SelectFieldComponent/SelectFieldComponent';

import messages from '../../../locale/messages';
import validate from './validate';
import submit from './submit';
import { updateTempImages } from '../../../actions/siteadmin/TempImages/updateTempImages';
import { api, subCategoryUploadDir } from '../../../config';
import { demoRestriction } from '../../../actions/demoRestriction';

import CommonImageDisplay from '../CommonImageDisplay/CommonImageDisplay';

import bt from '../../../components/commonStyle.css';
import s from './AddSubCategoryForm.css';

export class AddSubCategoryForm extends Component {
  static defaultProps = {
    currency: 'USD',
    loading: false,
  };

  constructor(props) {
    super(props);
    this.success = this.success.bind(this);
  }

  async success(file, fromServer) {
    const { change, updateTempImages, id, demoRestriction } = this.props;
    if (id) {
      const isRestrict = await demoRestriction({ restrictType: 'subCategory', restrictValue: id });
      if (isRestrict) return;
    }
    await change('image', fromServer && fromServer.fileName);
    await updateTempImages(
      'SubCategory',
      'image',
      fromServer && fromServer.fileName,
    );
  }

  render() {
    const {
      handleSubmit,
      image,
      loading,
      submitting,
      id,
      categories: { getActiveCategories },
      userIdentityLoading,
    } = this.props;
    const { formatMessage } = this.props.intl;

    const categoryOptions = [{ value: "", label: formatMessage(messages.category) }]
    const categoryOptionsFormatted = getActiveCategories && getActiveCategories.results && getActiveCategories.results.map(category => {
      return {
        value: category.id,
        label: category.name
      }
    })
    categoryOptionsFormatted && categoryOptions.push(...categoryOptionsFormatted);

    const statusOption = [
      { value: 'active', label: formatMessage(messages.active) },
      { value: 'inactive', label: formatMessage(messages.inactive) }
    ]
    return (
      <Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
        <h1 className='siteAdminPrimaryHeading'>
          {id
            ? formatMessage(messages.editSubCategory)
            : formatMessage(messages.addSubCategory)}
        </h1>

        <div className={cx(s.singleCard, bt.space4)}>
          <div className={cx(s.profileImgSection, s.profileImgWidth)}>
            <label className={bt.commonLabelText}>
              {formatMessage(messages.image)}
            </label>
            <CommonImageDisplay loader={userIdentityLoading} imageSrc={ image ? api?.apiEndpoint + subCategoryUploadDir + 'medium_' + image : null} />
            <ImageUploadComponent
              className='commonSiteAdminDropzoneSpace'
              subText={formatMessage(messages.maximumUploadSizeLabel)}
              defaultMessage={formatMessage(messages.chooseFile)}
              componentConfig={{
                iconFiletypes: ['.jpg', '.png'],
                multiple: false,
                showFiletypeIcon: false,
                postUrl: api.apiEndpoint + '/uploadSubCategory',
              }}
              success={this.success}
              loaderName={'userIdentityLoading'}
            />
          </div>
        </div>

        <div className='twoColumnGrid'>
          <Field
            name="name"
            type="text"
            placeholder={formatMessage(messages.subCategoryName)}
            component={InputFieldComponent}
            label={formatMessage(messages.subCategoryName)}
            inputClass={bt.formControlInput}
          />

          <Field
            name="description"
            type="text"
            placeholder={formatMessage(messages.description)}
            component={InputFieldComponent}
            componentClass="textarea"
            label={formatMessage(messages.description)}
            inputClass={bt.formTextArea}
          />

          <Field
            name="categoryId"
            placeholder={formatMessage(messages.category)}
            component={SelectFieldComponent}
            options={categoryOptions}
            label={formatMessage(messages.category)}
            inputClass={cx(bt.formControlSelect)}
          />

          <Field
            name="status"
            label={formatMessage(messages.status)}
            component={SelectFieldComponent}
            options={statusOption}
            inputClass={cx(bt.formControlSelect)}
          />
        </div>
        <div className='commonButtonContainer'>
          <Link to={'/siteadmin/sub-category'} className={bt.btnSecondary} >{formatMessage(messages.goBack)}</Link>
          <Loader
            type={'button'}
            label={formatMessage(messages.submitButton)}
            show={loading}
            buttonType={'submit'}
            className={cx(bt.btnPrimary, 'loaderButtonFlex')}
            disabled={submitting || loading}
          />
        </div>
      </Form>
    );
  }
}

AddSubCategoryForm = reduxForm({
  form: 'AddSubCategoryForm',
  onSubmit: submit,
  validate,
})(AddSubCategoryForm);

const selector = formValueSelector('AddSubCategoryForm');

const mapState = state => ({
  currency: state?.currency,
  image: selector(state, 'image'),
  id: selector(state, 'id'),
  loading: state?.loader?.AddSubCategory,
  userIdentityLoading: state?.loader?.userIdentityLoading,
});

const mapDispatch = {
  initialize,
  change,
  updateTempImages,
  demoRestriction
};

export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(AddSubCategoryForm)));
